<app-input-label [inputName]="name"></app-input-label>

<div class="content" 
    [innerHTML]="content">
</div>